module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/id-884fd633fd1b9477de97ff8c53f11662.jpg";